import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyClosedLeadTasks() {
    return (
        <OnboardingBody title='What are tasks?'>
            <div>
                <p>What do you need to do after a lead is closed?</p>
                <p>
                    Tasks might include calling a lost lead to understand why they took their
                    business elsewhere, or scheduling your first delivery with a new customer.
                </p>
            </div>
        </OnboardingBody>
    );
}
